export const getTokenFromUrl = () => {
  const tokenInUrl = window.location.search.indexOf('token');

  if (tokenInUrl === -1) return null;

  const tokenIndex = tokenInUrl + 6;
  const token = window.location.search.slice(tokenIndex, tokenIndex + 40);

  return token;
};
